<ion-card class="card" *ngIf="event" [class.collapsed]="collapsed" [color]="color">

  <div class="event-img">

    <!-- image -->
    <ion-img *ngIf="event.photos?.length; else placeholderTemplate" [src]="event.photos[0].medium" [alt]="event.photos[0].caption || 'Titelbild der Veranstaltung'"></ion-img>

    <ng-template #placeholderTemplate>
      <ion-img *ngIf="placeholder_image" [src]="placeholder_image" alt="Platzhalter"></ion-img>
    </ng-template>
    <!-- /image -->
  </div>


  <ion-accordion-group (ionChange)="collapsed = !$event.detail.value">
    <ion-accordion toggleIcon="caret-down">
        <ng-content></ng-content>
    </ion-accordion>
  </ion-accordion-group>
</ion-card>